// Prompt 0454 — Carga + refresh del puesto completo para AdminPuestoPanel
// Centraliza fetchPuesto(id) para que todos los tabs compartan el detalle mas fresco.

import { useState, useEffect, useCallback } from 'react';
import { fetchPuesto, type PuestoItem } from '../../../../../../shared/services/api';

export interface UsePuestoDataResult {
  detalle: PuestoItem | null;
  loading: boolean;
  refetch: () => Promise<void>;
}

export function usePuestoData(puestoId: string | null): UsePuestoDataResult {
  const [detalle, setDetalle] = useState<PuestoItem | null>(null);
  const [loading, setLoading] = useState(false);

  const refetch = useCallback(async () => {
    if (!puestoId) {
      setDetalle(null);
      return;
    }
    setLoading(true);
    try {
      const res = await fetchPuesto(puestoId);
      setDetalle(res.data);
    } catch {
      setDetalle(null);
    } finally {
      setLoading(false);
    }
  }, [puestoId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { detalle, loading, refetch };
}
